const Footer = () => {
  return (
    <footer className="bg-[#030303] text-gray-300 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        <div className="text-center text-sm sm:text-base">
          © {new Date().getFullYear()} Carbon. All rights reserved.
          <div className="mt-2 text-gray-400">
            Luxury Redefined | Excellence in Every Detail
          </div>
          <div className="mt-1 text-gray-500">
            Contact us: support@carbon.com
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
